import { StandardsConfirmAction } from "./StandardsConfirmAction.component";

export { StandardsConfirmAction };
